export default "__VITE_ASSET__1678c0a1__"